import { TypeAsserter, TypeChecker } from '@attain-apps/type-guards'

import type { User } from '../../user'
import type { Statement } from '../statement'

/**
 * Statements attached directly to one user, with no role involved
 */
export interface DirectPolicy {
  /** @see {@link DirectPolicy.Id} */
  readonly id: DirectPolicy.Id
  readonly userId: User.Id
  readonly statements: readonly Statement.Concrete[]
  /** Set on policies translated from the legacy `assignment` entity */
  readonly createdFrom: DirectPolicy.Provenance | null
  /** Epoch millis */
  readonly createdAt: number
  readonly createdBy: User.Id
}
export namespace DirectPolicy {
  /** Identifies a {@link DirectPolicy} */
  export type Id = string
  export namespace Id {
    export const isId: TypeChecker<Id> = TypeChecker.isString.usingAlias(
      'policy.grant.DirectPolicy.Id',
    )
    export const assertIsId: TypeAsserter<Id> = TypeAsserter.Factory.from(isId)
  }

  export interface Provenance {
    readonly migration: 'assignments-v1'
  }
}
